import { Box, FormControlLabel, Radio, SxProps, Theme } from "@mui/material";
import LabelHeader from "./LabelHeader";
import { ICarTireSizeUpItem } from "../../features/car_model/types";

/**
 * A React component that renders a labeled group of radio buttons.
 * @param {object} props - The props for the component.
 * @param {string} props.label - The label text displayed above the radio buttons.
 * @param {ICarTireSizeUpItem[]} props.option - An array of options for the radio buttons,
 * each containing a unique identifier and a label for the tire size.
 * @param {SxProps<Theme>} [props.sxLabel] - Optional styling for the label container.
 * @param {SxProps<Theme>} [props.sx] - Optional styling for the outer container.
 * @returns {JSX.Element} - A JSX element containing the labeled radio button group.
 */
export default function LabeledRadioBox({
  label,
  option,
  sx,
  sxLabel,
}: {
  label: string;
  option: ICarTireSizeUpItem[];
  sxLabel?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box sx={{ display: "flex", ...sx }}>
      <LabelHeader label={label} sxBox={sxLabel} sxTypography={{ marginRight: 2 }} />
      {option.map((item) => (
        <FormControlLabel
          key={item.mmm_idx}
          value={item.mmm_idx}
          sx={{ color: "var(--gray-400)" }}
          control={
            <Radio
              size="small"
              sx={{
                "&.Mui-checked": {
                  color: "var(--black)",
                },
              }}
            />
          }
          label={item.mmm_car_tiresize}
        />
      ))}
    </Box>
  );
}
